import isEmpty from 'lodash/isEmpty';

export const getAccessibleNavigationMenu = ({
  menuItems = [],
  services = [],
  features = [],
  roles = [],
  sitesEnabled = false,
}) => {
  return menuItems.reduce((prev, curr) => {
    if (!curr?.items) {
      // This is a single level item
      if (curr.alwaysVisible) {
        prev.push(curr);
        return prev;
      }
      if (
        shouldPush({ curr, sitesEnabled, services, features, roles }) &&
        !checkIfInPrev(prev, curr)
      ) {
        prev.push(curr);
      }
    } else {
      // multi level nav
      const reducedNestedLevels = curr.items.reduce((prev, curr) => {
        //check if current object is already added
        if (curr.alwaysVisible && !checkIfInPrev(prev, curr)) {
          prev.push(curr);
        }
        //We only push if all the options hold true

        if (
          shouldPush({ curr, sitesEnabled, services, features, roles }) &&
          !checkIfInPrev(prev, curr)
        ) {
          prev.push(curr);
        }
        return prev;
      }, []);
      if (!isEmpty(reducedNestedLevels)) {
        // only push to nav if reducedNestedLevels are not empty
        const navItem = curr;
        navItem.items = reducedNestedLevels;
        prev.push(navItem);
      }
    }

    return prev;
  }, []);
};
const shouldPush = ({ curr, sitesEnabled, services, features, roles }) => {
  let shouldView = true;
  if (curr?.enableSite) {
    //check the sites
    shouldView = sitesEnabled;
  }
  if (curr?.services && shouldView) {
    // if it has service then check for service
    if (!isEmpty(services)) {
      shouldView = curr.services.some(s => services.includes(s));
    }
  }
  if (curr?.feature && shouldView) {
    // if it has features, check for features in security company object
    shouldView = curr.feature.some(s => features.includes(s));
  }

  if (curr.roles && shouldView) {
    shouldView = curr.roles.some(s => roles.includes(s));
  }
  return shouldView;
};

const checkIfInPrev = (prev = [], val = {}) => {
  return prev.some(item =>
    Object.keys(item).every(key => item[key] === val[key]),
  );
};
